// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-content{display:flex}.tab-content .tab-pane{display:block;-webkit-animation:fadeIn .5s;animation:fadeIn .5s;width:100%}.wizard-navigation .nav-link.active,.wizard-navigation .nav-link.checked{cursor:pointer}.wizard-navigation .nav-link .md-icon{padding:0}.wizard-navigation .moving-tab .md-icon{color:#fff!important}.disabled-wizard-link{cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
